import React from 'react'
import { Button, Badge } from '@chakra-ui/react'
import useAuthStore from 'stores/authStore'
import { useNavigate } from 'react-router-dom'

const LogOutButton = () => {
    const setAccessToken = useAuthStore((state) => state.setAccessToken)
    const user = useAuthStore((state) => state.user)
    const navigate = useNavigate()
    return (<>
        <Badge variant='outline' colorScheme='green'>{`${user.name} ${user.last_name}`}</Badge>
        <Button 
            onClick={() => {
                setAccessToken('')
                navigate('/login')
            }} ml={2} 
            title={`${user.name} ${user.last_name} - Log Out`}>
            Log Out
        </Button>
    </>)
}

export default LogOutButton